export { default as Img200 } from './processed/200/My-Dad-Wrote-A-Porno.jpg';
export { default as Img400 } from './processed/400/My-Dad-Wrote-A-Porno.jpg';
export { default as Imgthumb } from './processed/thumb/My-Dad-Wrote-A-Porno.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/My-Dad-Wrote-A-Porno.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/My-Dad-Wrote-A-Porno.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      204,
      28,
      60
    ],
    "_population": 3,
    "_hsl": [
      0.9696969696969697,
      0.7586206896551724,
      0.4549019607843138
    ]
  },
  "LightVibrant": {
    "_rgb": [
      235,
      169,
      65
    ],
    "_population": 131,
    "_hsl": [
      0.1019607843137255,
      0.8095238095238093,
      0.588235294117647
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      135,
      6,
      34
    ],
    "_population": 527,
    "_hsl": [
      0.9638242894056847,
      0.9148936170212765,
      0.27647058823529413
    ]
  },
  "Muted": {
    "_rgb": [
      162,
      120,
      98
    ],
    "_population": 262,
    "_hsl": [
      0.05729166666666666,
      0.2559999999999999,
      0.5098039215686274
    ]
  },
  "LightMuted": {
    "_rgb": [
      194,
      148,
      128
    ],
    "_population": 259,
    "_hsl": [
      0.050505050505050546,
      0.351063829787234,
      0.6313725490196078
    ]
  },
  "DarkMuted": {
    "_rgb": [
      106,
      73,
      56
    ],
    "_population": 193,
    "_hsl": [
      0.05666666666666664,
      0.308641975308642,
      0.3176470588235294
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/My-Dad-Wrote-A-Porno.js